import { createApp, watch } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';

// Import PrimeVue theme functionality
import Aura from '@primeuix/themes/aura';

// Import CSS
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(ToastService);
app.use(ConfirmationService);
app.component('ConfirmDialog', ConfirmDialog);

// --- Theme Configuration ---
app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark-theme'
    }
  }
});

// Initialize stores
const authStore = useAuthStore();
const themeStore = useThemeStore();

// Apply dark mode class
watch(
  () => themeStore.isDarkMode,
  (isDark) => {
    const htmlElement = document.documentElement;
    if (isDark) {
      htmlElement.classList.add('dark-theme');
    } else {
      htmlElement.classList.remove('dark-theme');
    }
  },
  { immediate: true }
);

// Initialize app
// We do not await this, so the UI renders immediately.
// If the token is invalid, the store will handle the redirect to login asynchronously.
authStore.tryAutoLogin();

app.use(router);
app.mount('#app');
